import React, { Component } from 'react';

/**
 * AgentLogs — pure UI log renderer
 *
 * Props:
 *  - logs           : [{ timestamp, level, message }]
 *  - visible        : boolean   — show/hide the whole component
 *  - isExpanded     : boolean
 *  - onToggleExpanded : () => void
 *  - onClearLogs    : () => void
 */
export default class AgentLogs extends Component {
  formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', {
      hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  };

  getLevelIcon = (level) => {
    switch (level) {
      case 'progress': return '▶';
      case 'error': return '✕';
      case 'info': return 'ℹ';
      default: return '•';
    }
  };

  render() {
    const { logs = [], visible = true, isExpanded = true, onToggleExpanded, onClearLogs } = this.props;

    if (!visible) return null;

    return (
      <div className={`agent-logs ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="agent-logs-header" onClick={onToggleExpanded}>
          <div className="agent-logs-title">
            <span className="logs-icon">$</span>
            <span>Console</span>
            {logs.length > 0 && <span className="logs-count">{logs.length}</span>}
          </div>
          <div className="agent-logs-controls">
            {isExpanded && (
              <button
                className="clear-logs-btn"
                onClick={(e) => { e.stopPropagation(); onClearLogs?.(); }}
                title="Clear logs"
              >
                🗑
              </button>
            )}
            <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
          </div>
        </div>

        {isExpanded && (
          <div className="agent-logs-content">
            {logs.length === 0 ? (
              <div className="logs-empty">Waiting for logs...</div>
            ) : (
              <div className="logs-list">
                {logs.map((log, index) => (
                  <div key={index} className={`log-entry log-${log.level}`}>
                    <span className="log-timestamp">{this.formatTimestamp(log.timestamp)}</span>
                    <span className="log-level-icon">{this.getLevelIcon(log.level)}</span>
                    <span className="log-message">{log.message}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
